<script setup>
import { ref } from 'vue'
import { useNotification } from "@kyvg/vue3-notification";
import { useStore } from 'vuex'
import FormButton from '../Atoms/FormButton.vue'
import FloatingInput from '../ui/FloatingInput.vue'
import Sidebar from '../modals/Sidebar'
import MediaflowService from '@/services/MediaflowService';

const props = defineProps({
  mediaflowId: {
    type: String,
    default: '',
    required: true
  }
})

const store = useStore()
const { notify } = useNotification()

const sidebar = ref()
const error = ref(null)

const flow = ref({
  name: '',
})

const emit = defineEmits(['flow-added'])

const toggleSidebar = () => sidebar.value.toggleSidebar()

const onReset = () => {
  flow.value = { name: '' }
  error.value = null
}

const createFlow = async () => {
  try {
    console.log('mediaflowId', props.mediaflowId)
    const newFlow = await MediaflowService.createFlow(props.mediaflowId, flow.value.name)
    emit('flow-added', newFlow)
    notify({ group: 'success', text: 'Flow created.' })
    sidebar.value.closeSidebar()
  } catch (err) {
    error.value = err.message
  }
}

defineExpose({ toggleSidebar })
</script>

<template>
  <Sidebar ref="sidebar" :stage="1" @closed="onReset" width="md:w-[420px]">
    <template v-slot:stage-one>
      <div class="px-4 h-full">
        <h3 class="text-lg font-medium mb-2 mt-3">New Flow</h3>
        <p class="text-dark-7 mb-4 text-sm">Add a new flow to your Cloud Production.</p>
        <div class="mb-3">
          <FloatingInput id="add-flow-name" label="Flow name *" surface="2" dense v-model="flow.name" />
        </div>
        <div class="text-center">
          <FormButton :disabled="flow.name.length === 0" @click="createFlow" type="primary" size="md" class="w-full mt-4 justify-center">
            Create
          </FormButton>
          <FormButton type="secondary" size="md" class="w-full mb-3 mt-2 justify-center" @click="toggleSidebar">
            Cancel
          </FormButton>
        </div>
      </div>
    </template>
  </Sidebar>
</template>
